import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useRecentMembershipPayment } from "hooks/useRecentMembershipPayment";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";

const requestFormLinkSx = {
  color: "inherit",
  textDecoration: "underline",
  textUnderlineOffset: "2px",
  "&:hover": { color: COLORS.PRIMARY_DARK }
} as const;

const RequestCancellationRefundSection: React.FC = () => {
  const { hasRecentPayment, isLoading } = useRecentMembershipPayment();

  if (isLoading || !hasRecentPayment) {
    return null;
  }

  return (
    <Box
      data-testid="request-cancellation-refund-section"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        width: "100%",
        mt: 2,
        mb: 5
      }}
    >
      <Typography component="h2" variant="body_strong_dark_gray" sx={{ m: 0 }}>
        Request Cancellation and Refund
      </Typography>
      <Typography component="p" variant="body_dark_gray" sx={{ m: 0 }}>
        If you would like to request a cancellation and refund for a membership
        you&apos;ve recently purchased, please submit{" "}
        <Box
          component={RouterLink}
          sx={requestFormLinkSx}
          to={PATHS.ACCOUNT_MANAGEMENT_CANCEL_MEMBERSHIP}
        >
          our request form
        </Box>{" "}
        within 72 hours of purchase.
      </Typography>
    </Box>
  );
};

export default RequestCancellationRefundSection;
